import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TopLevelCategory } from "trimble-terra/SiteNav";
import PersonalizationExperience from "../Personalization/PersonalizationExperience";
import Link from "next/link";
const PersonalizedNavigationCategory = props => {
  const $ = _c(15);
  const data = props?.value;
  const t0 = props?.closeAllMenus;
  const t1 = props?.value?.passthroughProps;
  let t2;
  let t3;
  let t4;
  if ($[0] !== data?.navItem || $[1] !== t0 || $[2] !== t1) {
    const passthroughProps = {
      closeAllMenus: t0,
      ...t1
    };
    t3 = data?.navItem;
    t4 = passthroughProps;
    t2 = formattedNavCategoryExperiences(data?.navItem?.ntExperiencesCollection?.items, passthroughProps);
    $[0] = data?.navItem;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = {
      items: t2
    };
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      ...t3,
      passthroughProps: t4,
      ntExperiencesCollection: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const formattedData = t6;
  const t7 = data?.contentfulId;
  let t8;
  if ($[12] !== formattedData || $[13] !== t7) {
    t8 = <PersonalizationExperience id={t7} value={formattedData} BaselineComponent={TopLevelCategory} />;
    $[12] = formattedData;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default PersonalizedNavigationCategory;
const formattedNavCategoryExperiences = (experiences: any, passthroughProps: any) => {
  // this feels horrible having to do this, but the Personalization API forwards the Baseline component with
  // props directly without allowing for any client-side formatting such as URL formatters.
  // This custom formatter allows the proper formatted data + event handlers/state to pass in with the variant

  // NOTE - Passthrough Props necessary for open/close functions for nav items. Ideally we refactor this for mobile/desktop nav versions to keep consistent.

  if (!experiences?.length) return null;
  return experiences?.map((exp: any) => ({
    ...exp,
    contentfulId: exp?.id,
    id: exp?.id,
    passthroughProps: passthroughProps,
    ntVariantsCollection: {
      items: exp?.ntVariantsCollection?.items?.map((variant: any) => ({
        ...variant,
        LinkComponent: Link,
        passthroughProps: passthroughProps
      }))
    }
  }));
};